module.exports = __webpack_public_path__ + "ai.svg?377c542ad344b6c40fd30645601fdb01";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/ai.svg
// module id = 1219
// module chunks = 0